export enum TemperatureCalculationMode {
  TEMPERATURE_GAIN = 'Temperature Gain',
  OUTLET_TEMPERATURE = 'Outlet Temperature',
  TEMPERATURE_DROP = 'Temperature Drop',
}
